import { useAppConfig } from '../../hooks/useAppConfig';

export default function Features() {
  const appConfig = useAppConfig();
  
  const features = [
    {
      icon: 'ri-hd-line',
      title: '4K Ultra HD Quality',
      description: 'Experience crystal-clear wallpapers in stunning 4K resolution that make your device screen come alive with vibrant colors and sharp details.'
    },
    {
      icon: 'ri-heart-line',
      title: 'Like & Save Favorites',
      description: 'Build your personal collection by liking wallpapers you love. Access your favorites anytime and never lose track of stunning designs.'
    },
    {
      icon: 'ri-download-cloud-line',
      title: 'One-Tap Download',
      description: 'Download wallpapers instantly with a single tap. No complicated processes, just quick and easy access to premium content.'
    },
    {
      icon: 'ri-smartphone-line',
      title: 'Direct Wallpaper Setting',
      description: 'Set wallpapers directly from the app without leaving the interface. Seamless integration with your device settings.'
    },
    {
      icon: 'ri-refresh-line',
      title: 'Daily Fresh Content',
      description: 'Discover new wallpapers every day with our constantly updated collection featuring trending designs and seasonal themes.'
    },
    {
      icon: 'ri-palette-line',
      title: 'Multiple Categories',
      description: 'Browse through diverse categories including nature, abstract, technology, minimalist, and artistic designs to match your style.'
    }
  ];

  return (
    <section id="features" className="py-20 bg-gray-50">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h3 className="text-4xl font-bold text-gray-900 mb-4">
            Why Choose <span 
              className="bg-gradient-to-r bg-clip-text text-transparent"
              style={{
                backgroundImage: `linear-gradient(to right, ${appConfig.primaryColor}, ${appConfig.secondaryColor})`
              }}
            >
              {appConfig.name}
            </span>?
          </h3>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Experience the ultimate wallpaper app with premium features designed to enhance your mobile device experience
          </p>
        </div>
        
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div key={index} className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-2">
              <div 
                className="w-16 h-16 rounded-2xl flex items-center justify-center mb-6"
                style={{
                  background: `linear-gradient(to right, ${appConfig.primaryColor}, ${appConfig.secondaryColor})`
                }}
              >
                <i className={`${feature.icon} text-2xl text-white`}></i>
              </div>
              <h4 className="text-xl font-bold text-gray-900 mb-4">{feature.title}</h4>
              <p className="text-gray-600 leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
